import { gql } from '@apollo/client'
import { PACKAGING_FRAGMENT } from './PackagingFragment'
import { SHIPPING_FRAGMENT } from './ShippingFragment'

export const WHITE_RABBIT_SIMPLE_PRODUCT_FRAGMENT = gql`
  fragment WhiteRabbitSimpleProduct on Product {
    id
    upcA
    upcE
    name
    isActive
    brand {
      id
      name
    }
    manufacturer {
      id
      name
    }
    marketingImageUrl
    packaging {
      ...Packaging
    }
    shipping {
      ...Shipping
    }
    flavors {
      id
      flavor
      displayFlavor
    }
    companyCategory {
      id
      category
      parentCategory
    }
    geometry {
      id
      geometry
    }
    verifiedBy
  }
  ${PACKAGING_FRAGMENT}
  ${SHIPPING_FRAGMENT}
`
